import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { dateinputconverter } from "Component/DynamicForm/Fields/Date";
import { integerinputconverter } from "Component/DynamicForm/Fields/Integer";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { withSnackbar } from "notistack";
import { moment } from 'moment';
import React from "react";
import { getEJ2CalenderDateFormat } from "Utils";

export class Screeningquestion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companyquestiondata:
        (this.props.candidateDetails[0] &&
          this.props.candidateDetails[0].questionFeedback &&
          this.props.candidateDetails[0].questionFeedback) ||
        [],
    };
  }

  componentDidUpdate() {}

  renderQuestions = (data, index, id) => (
    <div>
      <p className="normal-dark">{data.question.questiontext} </p>

      {data.question && (
        <div>
          {data.question.inputvaluetypeid == 1 ? (
            <DynamicForm
              fields={textinputconverter({
                value: data.feedback,
                placeholder: "",
                disabled: true,
              })}
              onChange={(e) => {}}
            />
          ) : data.question.inputvaluetypeid == 2 ? (
            <DynamicForm
              fields={integerinputconverter({
                value: data.feedback,
                placeholder: "",
                min: 0,
                max: 1000,
                disabled: true,
              })}
              onChange={(e) => {}}
            />
          ) : data.question.inputvaluetypeid == 3 ? (
            <DynamicForm
              fields={dateinputconverter({
                value: data.feedback,
                placeholder: "",
                min: data.question.isexpiryfield ? new Date() : null,
                disabled: true,
              })}
              onChange={(e) => {}}
            />
          ) : data.question.inputvaluetypeid == 4 ? (
            (
              data.question.requisitionjobquestioninputoption.map((y) => (
                <div>
                  <DynamicForm
                    fields={radioinputconverter({
                      value: data.requisitionjobquestioninputoptionids && data.requisitionjobquestioninputoptionids.split(",").some((input) => input == y.questioninputoptionid),
                      placeholder: "",
                      label: y.optionname,
                      disabled: true,
                    })}
                    onChange={(value) => {}}
                  />
                </div>
              ))
            )
          ) : (
            data.question.requisitionjobquestioninputoption.map((y) => (
              <div>
                <DynamicForm
                  fields={checkboxinputconverter({
                    value: data.requisitionjobquestioninputoptionids && data.requisitionjobquestioninputoptionids.split(",").some((input) => input == y.questioninputoptionid),
                    placeholder: "",
                    label: y.optionname,
                    disabled: true,
                  })}
                  onChange={(value) => {}}
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );

  render() {
    return (
      <div>
        {this.state.companyquestiondata &&
          this.state.companyquestiondata.filter(
            (x) => x.questioncategoryid == 1,
          ).length > 0 && (
            <div className="dashed-divider1 position-rel text-center">
              <span
                style={{
                  background: "#fff",
                  position: "relative",
                  top: -14,
                  padding: "0px 24px",
                }}
                className="extra-small-dark-secondary"
              >
                Company and culture questions
              </span>
            </div>
          )}

        {this.state.companyquestiondata &&
          this.state.companyquestiondata.filter(
            (x) => x.questioncategoryid == 2,
          ).length > 0 &&
          this.state.companyquestiondata.map((x, index) =>
            this.renderQuestions(x, index, 3),
          )}

        <div className="dashed-divider1 position-rel text-center">
          <span
            style={{
              background: "#fff",
              position: "relative",
              top: -14,
              padding: "0px 24px",
            }}
            className="extra-small-dark-secondary"
          >
            Functional and role questions
          </span>
        </div>

        {this.state.companyquestiondata &&
          this.state.companyquestiondata.length > 0 &&
          this.state.companyquestiondata.map((x, index) =>
            this.renderQuestions(x, index, 1),
          )}
      </div>
    );
  }
}

export default withSnackbar(Screeningquestion);
